import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase-config';
import { CustomProductBulkTarget } from '../types/customProductBulkActions';
import { unwrapCallableData } from './callableResponse';

type DownloadAllCustomProductAmazonGenerationsRequest = {
    companyId: string;
} & Partial<CustomProductBulkTarget>;

interface DownloadAllCustomProductAmazonGenerationsResponse {
    filePath: string;
    bucketName: string;
}


const downloadAllCustomProductAmazonGenerations = async (companyId: string, target?: CustomProductBulkTarget): Promise<DownloadAllCustomProductAmazonGenerationsResponse> => {
    const downloadAllCustomProductAmazonGenerations = httpsCallable<DownloadAllCustomProductAmazonGenerationsRequest, any>(functions, 'download_all_custom_product_amazon_generations');
    const result = await downloadAllCustomProductAmazonGenerations({ companyId, ...target });

    return unwrapCallableData<DownloadAllCustomProductAmazonGenerationsResponse>(result.data);
};

export { downloadAllCustomProductAmazonGenerations };
